import { createRoute, lazyRouteComponent } from "@tanstack/react-router";

import { authenticatedRoute } from "../_authenticated.js";

export const settingsTokensRoute = createRoute({
  getParentRoute: () => authenticatedRoute,
  path: "/settings/tokens",
  component: lazyRouteComponent(() => import("./settings.tokens.page.js"), "TokensPage"),
});
